<template lang="pug">
  tbody
    tr
      th {{ $t("ui.parlay") }}
      th {{ parlay_title }}
      td
        PTSelect(
          ref="parlay_upline_pt"
          :dirty="$v.parlay_upline_pt.$dirty"
          :error="$v.parlay_upline_pt.$error"
          :options="parlay_upline_options"
          :value="parlay_upline_pt"
          @input="input_parlay_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_account_pt"
          :dirty="$v.parlay_account_pt.$dirty"
          :error="$v.parlay_account_pt.$error"
          :options="parlay_account_options"
          :value="parlay_account_pt"
          @input="input_parlay_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_upline_remaining"
          :dirty="$v.parlay_upline_remaining.$dirty"
          :error="$v.parlay_upline_remaining.$error"
          :options="parlay_account_options"
          :value="parlay_upline_remaining"
          @input="$v.parlay_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_account_min"
          :dirty="$v.parlay_account_min.$dirty"
          :error="$v.parlay_account_min.$error"
          :options="parlay_min_options"
          :value="parlay_account_min"
          @input="$v.parlay_account_min.$model = $event"
          :disabled="loading"
        )
    tr(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency) && !isEdit")
      th {{ $t("ui.parlay") }} MMO
      th {{ parlay_mmo_title }}
      td
        PTSelect(
          ref="parlay_mmo_upline_pt"
          :dirty="$v.parlay_mmo_upline_pt.$dirty"
          :error="$v.parlay_mmo_upline_pt.$error"
          :options="parlay_mmo_upline_options"
          :value="parlay_mmo_upline_pt"
          @input="input_parlay_mmo_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_mmo_account_pt"
          :dirty="$v.parlay_mmo_account_pt.$dirty"
          :error="$v.parlay_mmo_account_pt.$error"
          :options="parlay_mmo_account_options"
          :value="parlay_mmo_account_pt"
          @input="input_parlay_mmo_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_mmo_upline_remaining"
          :dirty="$v.parlay_mmo_upline_remaining.$dirty"
          :error="$v.parlay_mmo_upline_remaining.$error"
          :options="parlay_mmo_account_options"
          :value="parlay_mmo_upline_remaining"
          @input="$v.parlay_mmo_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="parlay_mmo_account_min"
          :dirty="$v.parlay_mmo_account_min.$dirty"
          :error="$v.parlay_mmo_account_min.$error"
          :options="parlay_mmo_min_options"
          :value="parlay_mmo_account_min"
          @input="$v.parlay_mmo_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: "",
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      parlay_upline_pt: 0,
      parlay_account_pt: 0,
      parlay_upline_remaining: 0,
      parlay_account_min: 0,
      parlay_mmo_upline_pt: 0,
      parlay_mmo_account_pt: 0,
      parlay_mmo_upline_remaining: 0,
      parlay_mmo_account_min: 0
    }
  },
  validations: {
    parlay_upline_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          total = value
        } else {
          total = value + this.parlay_account_pt
        }
        if(total < this.parlay_upline_min) {
          return false
        } else {
          return true
        }
      }
    },
    parlay_account_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          return true
        } else {
          total = value + this.parlay_upline_pt
          if(total < this.parlay_upline_min) {
            return false
          } else {
            return true
          }
        }
      }
    },
    parlay_upline_remaining: {
      required
    },
    parlay_account_min: {
      required
    },
    parlay_mmo_upline_pt: {
      required,
      minValue(value) {
        if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency) && !this.isEdit) {
          let total = 0
          if(this.$helpers.isAgentLevel()) {
            total = value
          } else {
            total = value + this.parlay_mmo_account_pt
          }
          if(total < this.parlay_mmo_upline_min) {
            return false
          } else {
            return true
          }
        } else {
          return minValue(0)(value)
        }
      }
    },
    parlay_mmo_account_pt: {
      required,
      minValue(value) {
        if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency) && !this.isEdit) {
          let total = 0
          if(this.$helpers.isAgentLevel()) {
            return true
          } else {
            total = value + this.parlay_mmo_upline_pt
            if(total < this.parlay_mmo_upline_min) {
              return false
            } else {
              return true
            }
          }
        } else {
          return minValue(0)(value)
        }
      }
    },
    parlay_mmo_upline_remaining: {
      required
    },
    parlay_mmo_account_min: {
      required
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    parlay_title: function () {
      return this.$t("ui.parlay") + " (" + this.parlay_upline_min + "%-" + this.parlay_upline_max + "%)"
    },
    parlay_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'PARLAY', 'PARLAY', 'account_min')
    },
    parlay_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'PARLAY', 'PARLAY', 'account_pt')
    },
    parlay_account_max: function() {
      return this.parlay_upline_max - this.parlay_upline_pt
    },
    parlay_upline_options: function() {
      return this.$helpers.getPTRateList(this.parlay_upline_max)
    },
    parlay_account_options: function() {
      return this.$helpers.getPTRateList(this.parlay_account_max)
    },
    parlay_min_options: function() {
      return this.$helpers.getPTRateList(this.parlay_account_pt)
    },
    parlay_mmo_title: function () {
      return this.$t("ui.parlay") + " (" + this.parlay_mmo_upline_min + "%-" + this.parlay_mmo_upline_max + "%)"
    },
    parlay_mmo_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'PARLAYMMO', 'PARLAYMMO', 'account_min')
    },
    parlay_mmo_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'PARLAYMMO', 'PARLAYMMO', 'account_pt')
    },
    parlay_mmo_account_max: function() {
      return this.parlay_mmo_upline_max - this.parlay_mmo_upline_pt
    },
    parlay_mmo_upline_options: function() {
      return this.$helpers.getPTRateList(this.parlay_mmo_upline_max)
    },
    parlay_mmo_account_options: function() {
      return this.$helpers.getPTRateList(this.parlay_mmo_account_max)
    },
    parlay_mmo_min_options: function() {
      return this.$helpers.getPTRateList(this.parlay_mmo_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.parlay_upline_pt.$model = this.parlay_upline_max
      if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
        this.$v.parlay_mmo_upline_pt.$model = this.parlay_mmo_upline_max
      }
    }
  },
  methods: {
    input_parlay_upline_pt(e) {
      this.$v.parlay_upline_pt.$model = e
      this.$v.parlay_account_pt.$model = this.parlay_account_max

      if (this.parlay_upline_remaining > this.parlay_account_max) {
        this.$v.parlay_upline_remaining.$model = 0
      }
      if (this.parlay_account_min > this.parlay_account_pt) {
        this.$v.parlay_account_min.$model = 0
      }
    },
    input_parlay_account_pt(e) {
      this.$v.parlay_account_pt.$model = e
      if (this.parlay_account_min > this.parlay_account_pt) {
        this.$v.parlay_account_min.$model = 0
      }
    },
    input_parlay_mmo_upline_pt(e) {
      this.$v.parlay_mmo_upline_pt.$model = e
      this.$v.parlay_mmo_account_pt.$model = this.parlay_mmo_account_max

      if (this.parlay_mmo_upline_remaining > this.parlay_mmo_account_max) {
        this.$v.parlay_mmo_upline_remaining.$model = 0
      }
      if (this.parlay_mmo_account_min > this.parlay_mmo_account_pt) {
        this.$v.parlay_mmo_account_min.$model = 0
      }
    },
    input_parlay_mmo_account_pt(e) {
      this.$v.parlay_mmo_account_pt.$model = e
      if (this.parlay_mmo_account_min > this.parlay_mmo_account_pt) {
        this.$v.parlay_mmo_account_min.$model = 0
      }
    }
  }
}

</script>